import { render, staticRenderFns } from "./RecipientTable.vue?vue&type=template&id=a3555b84"
import script from "./RecipientTable.vue?vue&type=script&lang=js"
export * from "./RecipientTable.vue?vue&type=script&lang=js"
import style0 from "./RecipientTable.vue?vue&type=style&index=0&id=a3555b84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports